export default __webpack_public_path__ + "static/media/DoubleDay12_750x600.0d984182.jpg";